import { addDays, startOfDay, startOfToday } from 'date-fns';
import * as logger from 'loglevel';
import type { Moment } from 'moment';
import { UNSAFE_getMoment } from './moment';

export function getDate(date?: Moment | string | number, formatHint?: string): Date | undefined {
  let resolvedDate;
  if (typeof date === 'object' && date.toDate) {
    resolvedDate = date.toDate();
  } else if (typeof date === 'string') {
    const momentObj = UNSAFE_getMoment();
    if (momentObj) {
      // console.log(momentObj);
      // console.log(formatHint);
      resolvedDate = momentObj(date, formatHint, true);
      if (!resolvedDate.isValid()) {
        resolvedDate = momentObj(date);
      }
      resolvedDate = startOfDay(resolvedDate.toDate());
    } else {
      logger.warn(
        `INTEGRATION_ACTIONS: **OpenPopupAction** window.EM.___fcRuntime.vendors.moment not 
              available as global variable and the **Booking Popup** needed it`
      );
      resolvedDate = startOfDay(new Date(date));
    }
  } else if (typeof date === 'number') {
    resolvedDate = addDays(startOfToday(), date);
  }

  if (resolvedDate && isNaN(resolvedDate.getTime())) {
    return undefined;
  }
  return resolvedDate;
}
